import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";
import { AccountType } from "@app/models/account-type";

@Injectable({
  providedIn: 'root'
})
export class AccountTypeService extends BaseRestService {

  readonly ACCOUNT_TYPE_URL: string = environment.apiUri + '/account-type';

  getList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.ACCOUNT_TYPE_URL, options);
  }

  /**
   * Get account type list sorted by main account types
   * @param pageParams
   */
  getSortedList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.ACCOUNT_TYPE_URL, options);
  }

  getSubListByParentId(id: string): Observable<any> {
    return this.httpClient.get(this.ACCOUNT_TYPE_URL + "/" + id,
      { headers: this.headers });
  }

  getAccountById(id: string): Observable<any> {
    return this.httpClient.get(this.ACCOUNT_TYPE_URL + "/" + id,
        { headers: this.headers });
  }

  getAccountTypeByCode(code: string): Observable<any> {
    return this.httpClient.get(this.ACCOUNT_TYPE_URL + "/code/" + code,
      { headers: this.headers });
  }

  getAccountTypeByGl(glRequest: any): Observable<any> {
    return this.httpClient.post(this.ACCOUNT_TYPE_URL + "/gl/type",
        glRequest,
        { headers: this.headers });
  }

  create(data: AccountType): Observable<any> {
    return this.httpClient.post(this.ACCOUNT_TYPE_URL, JSON.stringify(data),
      { headers: this.headers });
  }

  update(id: string, accountType: AccountType): Observable<any> {
    return this.httpClient.put(this.ACCOUNT_TYPE_URL + "/" + id, JSON.stringify(accountType),
      { headers: this.headers });
  }

  /**
   * Enable/disable account by Id
   * @param id
   * @param status:string enable/disable
   */
  updateStatus(id: string, status: string): Observable<any> {
    const url = `${this.ACCOUNT_TYPE_URL}/${id}/${status}`;
    return this.httpClient.put(url, null, {
      headers: this.headers
    });
  }

  /**
   * Delete GL code by id
   * @param id
   */
  delete(id: string): Observable<any> {
    return this.httpClient.delete(this.ACCOUNT_TYPE_URL + "/" + id + "/remove",
      { headers: this.headers });
  }

  customerAvailableList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.ACCOUNT_TYPE_URL + "/customer", options);
  }

}